module.exports = __webpack_public_path__ + "img/documents-selected.02c05878.svg";